export default __webpack_public_path__ + "static/media/IMG_5911.7b26a0ca.jpg";